import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i1 from '@play/api-client';
import { map, startWith } from 'rxjs/operators';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@play/translate';
import { TranslationModule } from '@play/translate';

function RegionSuggestionComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "a", 3);
    i0.ɵɵelement(3, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "a", 3);
    i0.ɵɵelement(6, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RegionSuggestionComponent_div_6_div_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const region_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", "/" + region_r5.page, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", region_r5.name, " ");
} }
function RegionSuggestionComponent_div_6_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const region_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(region_r5.name);
} }
function RegionSuggestionComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, RegionSuggestionComponent_div_6_div_1_a_1_Template, 2, 2, "a", 6);
    i0.ɵɵtemplate(2, RegionSuggestionComponent_div_6_div_1_div_2_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const region_r5 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", region_r5.page);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !region_r5.page);
} }
function RegionSuggestionComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, RegionSuggestionComponent_div_6_div_1_Template, 3, 2, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const regionSuggestions_r3 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", regionSuggestions_r3);
} }
function RegionSuggestionComponent_p_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "regions:could-not-determine"));
} }
class RegionSuggestionComponent {
    constructor(user) {
        this.user = user;
    }
    ngOnInit() {
        this.regionSuggestions$ = this.user.getUserRegions().pipe(map(data => this.convertData(data)), startWith([]));
        this.isLoading$ = this.regionSuggestions$.pipe(map(data => (data ? !data.length : false)));
        this.isReady$ = this.isLoading$.pipe(map(loading => Boolean(!loading)));
    }
    convertData(data) {
        const list = [];
        let item;
        let root = null;
        let current;
        let parent;
        const result = [];
        let currentList = [];
        let references = [];
        const global = {
            name: "Global",
            page: "global",
            key: "global",
            references: [],
            parent: null,
        };
        for (const key in data) {
            if (!data.hasOwnProperty(key) && typeof data[key] !== "object") {
                continue;
            }
            // Filter $promise
            if (key.indexOf("$") !== -1) {
                continue;
            }
            data[key].key = key;
            item = data[key];
            list.push(item);
        }
        if (!list.length) {
            return null;
        }
        // Last in result list
        root = list
            .filter(function (entry) {
            return entry.parent === null;
        })
            .pop();
        // First in result list
        currentList = list.filter(function (entry) {
            return entry.parent !== null && entry.parent !== root.key;
        });
        if (!currentList.length) {
            current = list
                .filter(function (entry) {
                return entry.parent === root.key;
            })
                .pop();
        }
        else {
            current = currentList.pop();
            parent = data[current.parent];
        }
        // Get references
        if (current.references.length) {
            references = list.filter(function (entry) {
                return current.references.indexOf(entry.key) !== -1;
            });
        }
        // Build result
        result.push(current);
        if (parent) {
            result.push(parent);
        }
        while (references.length) {
            result.push(references.shift());
        }
        result.push(root);
        result.push(global);
        return result;
    }
}
RegionSuggestionComponent.ɵfac = function RegionSuggestionComponent_Factory(t) { return new (t || RegionSuggestionComponent)(i0.ɵɵdirectiveInject(i1.UserResource)); };
RegionSuggestionComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RegionSuggestionComponent, selectors: [["region-suggestion"]], decls: 12, vars: 16, consts: [[1, "region-suggestions"], [4, "ngIf"], ["class", "error", 4, "ngIf"], ["disabled", "", 1, "c-button", "c-button--primary", "c-button--huge", "c-button--region"], [1, "c-skeleton__text", "c-skeleton__text--region-button"], [4, "ngFor", "ngForOf"], ["class", "c-button c-button--primary c-button--huge c-button--region", 3, "href", 4, "ngIf"], ["class", "region-suggestions__not-available", 4, "ngIf"], [1, "c-button", "c-button--primary", "c-button--huge", "c-button--region", 3, "href"], [1, "region-suggestions__not-available"], [1, "error"]], template: function RegionSuggestionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "p");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, RegionSuggestionComponent_div_4_Template, 7, 0, "div", 1);
        i0.ɵɵpipe(5, "async");
        i0.ɵɵtemplate(6, RegionSuggestionComponent_div_6_Template, 2, 1, "div", 1);
        i0.ɵɵpipe(7, "async");
        i0.ɵɵpipe(8, "async");
        i0.ɵɵtemplate(9, RegionSuggestionComponent_p_9_Template, 3, 3, "p", 2);
        i0.ɵɵpipe(10, "async");
        i0.ɵɵpipe(11, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "regions:region-suggestion-text"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 6, ctx.isLoading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 8, i0.ɵɵpipeBind1(8, 10, ctx.isReady$) && ctx.regionSuggestions$));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 12, ctx.isReady$) && !i0.ɵɵpipeBind1(11, 14, ctx.regionSuggestions$));
    } }, directives: [i2.NgIf, i2.NgForOf], pipes: [i3.TranslatePipe, i2.AsyncPipe], styles: [".region-suggestions[_ngcontent-%COMP%]{text-align:center}.region-suggestions__not-available[_ngcontent-%COMP%]{visibility:hidden;height:0}.c-button--region[_ngcontent-%COMP%]{width:50%;margin:0 20px 10px 0}.c-skeleton__text--region-button[_ngcontent-%COMP%]{background-image:linear-gradient(90deg,var(--midnight-grey4) 8%,var(--midnight-grey3) 18%,var(--midnight-grey4) 33%);margin:0 auto;height:1em}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegionSuggestionComponent, [{
        type: Component,
        args: [{
                selector: "region-suggestion",
                templateUrl: "./region-suggestion.component.html",
                styleUrls: ["./region-suggestion.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.UserResource }]; }, null); })();

const regionSuggestionsTexts = {
    "regions:region-suggestion-text": "Based on your country of origin, we think the following regions are relevant to you:",
    "regions:could-not-determine": "Could not determine your region",
};

class RegionModule {
}
RegionModule.ɵfac = function RegionModule_Factory(t) { return new (t || RegionModule)(); };
RegionModule.ɵmod = i0.ɵɵdefineNgModule({ type: RegionModule });
RegionModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, TranslationModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RegionModule, { declarations: [RegionSuggestionComponent], imports: [CommonModule, TranslationModule], exports: [RegionSuggestionComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegionModule, [{
        type: NgModule,
        args: [{
                declarations: [RegionSuggestionComponent],
                imports: [CommonModule, TranslationModule],
                exports: [RegionSuggestionComponent],
            }]
    }], null, null); })();

/*
 * Public API Surface of region
 */

/**
 * Generated bundle index. Do not edit.
 */

export { RegionModule, RegionSuggestionComponent, regionSuggestionsTexts };
//# sourceMappingURL=play-region.js.map
